import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class DatasetDiagram extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("DatasetDiagram constructor", this.props);
        this.params = this.props.router.params;
        
        this.state = {
        };
        
        this.openPopup = this.openPopup.bind(this);
    }

    openPopup()
    {
        //console.log('DatasetDelete');
        var this_component = this;

        if( !(`hash` in this_component.props) || this_component.props.hash=='' ) { console.log('DatasetDiagram openPopup Undefined value for `hash`'); return false; }

        monday.execute('openAppFeatureModal', { 
            'urlPath': 'dataset/diagram/'+this_component.props.hash, 
            'urlParams': {}, 
            'height': (window.innerHeight-(window.innerHeight/10))+'px', 
            'width': (window.innerWidth-(window.innerWidth/10))+'px' 
        }).then((res) => {
            //console.log(res.data);
            // {"close": true}
            // The above is a callback to see if a user closed the modal from the inside. This is useful should you want to run some logic within the app window. 
        });
    }
    
    render()
    {
        var this_component = this;
        
        return (null);
    }
}

DatasetDiagram.defaultProps = {
    style: {'display': 'inline-block'}
};

export default withRouter(withAuth(DatasetDiagram));
